import { Link } from "react-router";
import Card from "@particles/card/Card";
import {
  MyAccounMyBTPopoverListProps,
  MyAccountMyBTBasicCardProps,
} from "@routes/MyAccount/utils/types";

export default function MyAccounMyBTPopoverList({
  tagWithArticleList,
}: MyAccounMyBTPopoverListProps): React.ReactElement {
  return (
    <div data-testid="my-account-recent-read-popover-list-component">
      <div>
        {tagWithArticleList.map((tagList) => {
          const { tag, articles } = tagList;

          return (
            <div className="mb-6 last:mb-0" key={`my-bt-popover-${tag.id}`}>
              <Link
                to={tag.urlPath}
                reloadDocument
                className="mb-3 inline-block w-max rounded-sm bg-gray-250/50 p-2 font-poppins text-4xs text-gray-850"
              >
                {tag.name}
              </Link>

              <div>
                {articles.map((article) => {
                  return (
                    <MyAccounMyBTPopoverBasicCard
                      key={article.id}
                      article={article}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function MyAccounMyBTPopoverBasicCard({
  article,
}: MyAccountMyBTBasicCardProps): React.ReactElement {
  return (
    <div
      className="flex justify-between border-b border-gray-175 py-2 antialiased first:pt-0 last:border-b-0"
      data-testid={`recent-read-popover-basic-card-${article.id}`}
    >
      <Card
        {...article}
        variations={{
          section: {
            extraClass: "text-gray-850",
          },
          title: {
            size: "text-base",
            color: "!text-gray-850 font-lct",
          },
          content: {
            width: "w-full",
            extraClass: "h-full",
          },
        }}
      />
    </div>
  );
}
